import { render, staticRenderFns } from "./second.vue?vue&type=template&id=0b16bcc4&scoped=true&"
import script from "./second.vue?vue&type=script&lang=js&"
export * from "./second.vue?vue&type=script&lang=js&"
import style0 from "./second.vue?vue&type=style&index=0&id=0b16bcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16bcc4",
  null
  
)

export default component.exports